import type { MouseEvent } from 'react';

/**
 * True for a click that the browser will use to open a link in a new tab/window (ctrl/cmd/shift/middle-click).
 * Use this to skip same-tab side effects (navigation, closing a drawer) that a real `<a>` already
 * avoids on its own for these clicks.
 */
export function isModifiedClick(event: MouseEvent): boolean {
  return event.button !== 0 || event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
}
